import { RouterProvider } from "react-router";
import { QueryProvider, RunProvider } from "./providers";
import { router } from "./routes";

/** Composition root: providers wrapped around the router. */
export function App() {
  return (
    <QueryProvider>
      <RunProvider>
        <RouterProvider router={router} />
      </RunProvider>
    </QueryProvider>
  );
}
